import LoginComponent from "../components/login/login.component";
import MainLayoutComponent from "../components/main-layout/main-layout";


const MainLayout = () => {

    return (
        <>
            <MainLayoutComponent></MainLayoutComponent>
        </>
    )

}

export default MainLayout;